import { SectionedGroup } from "../components/types";

/**
 * Checks whether groups are equal based on the groupIds present in the nested structure
 * @param groups1 First set of groups to compare
 * @param groups2 Second set of groups to compare
 * @returns false if the group IDs do not match in the same order at any level of the tree
 */
export const areGroupsEqual = (groups1: SectionedGroup[], groups2: SectionedGroup[]) => {
    if (groups1 === groups2 && groups1 === undefined) {
        // Both are undefined, we can't do any further comparisons
        return true;
    }

    if (groups1.length !== groups2.length) {
        return false;
    }

    for (let index = 0; index <= groups1.length; index += 1) {
        const group1 = groups1[index];
        const group2 = groups2[index];

        if (group1 === undefined && group2 === undefined) {
            // If both these groups are undefined, they are the same, so continue our loop
            // eslint-disable-next-line no-continue
            continue;
        }

        if (group1.group.groupId !== group2.group.groupId) {
            return false;
        }

        // Recurse down the tree into the subgroups
        if (!areGroupsEqual(group1.subGroups, group2.subGroups)) {
            return false;
        }
    }

    // Since all the above have been looking for differences between the groups, if we got this far, they're the same
    return true;
};
